export default "__VITE_ASSET__SvE3SsR___"